import { useEffect, useState } from 'react';

export default function useOperationTelemetry() {
  const [feed, setFeed] = useState({ available: false, data: null });
  useEffect(() => {
    let stopped = false, timer, controller;
    const poll = async () => {
      controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 9000);
      try {
        const response = await fetch('/api/security/telemetry', { cache: 'no-store', signal: controller.signal });
        const result = await response.json();
        if (!stopped) setFeed(response.ok && result.available === true ? result : { available: false, data: null });
      } catch (_) { if (!stopped) setFeed({ available: false, data: null }); }
      finally {
        clearTimeout(timeout);
        if (!stopped) timer = setTimeout(poll, 10000);
      }
    };
    poll();
    return () => { stopped = true; controller?.abort(); clearTimeout(timer); };
  }, []);
  return feed;
}
